// extracted by mini-css-extract-plugin
module.exports = {"emptyImageContainer":"style_emptyImageContainer__2hwss"};